import { useEffect, useRef } from "react";
import Webcam from "react-webcam";

/**
 * Convert base64 image to File
 */
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default function AutoCamera({ running, onFrame }) {
  const webcamRef = useRef(null);
  const videoReadyRef = useRef(false);



// Auto capture loop
  useEffect(() => {
    if (!running) return;

    const interval = setInterval(() => {
      if (!webcamRef.current || !videoReadyRef.current) return;

      const img = webcamRef.current.getScreenshot();

      if (!img) return; // skip empty frames

      // Optional: resize image for faster detection
      // This prevents very large images breaking your model
      onFrame(dataURLtoFile(img, "face.jpg"));
    }, 1500);

    return () => clearInterval(interval);
  }, [running, onFrame]);

  return (
    <div className="relative w-full h-full rounded-2xl overflow-hidden bg-black">
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        className="w-full h-full object-contain"
        onUserMedia={() => {
          videoReadyRef.current = true;
          console.log("✅ Camera ready");
        }}
        // 🔹 Use lower resolution to match face detection model
        videoConstraints={{
          facingMode: "user",
          width: 640,
          height: 640,
        }}
      />
    </div>
  );
}
